import DeliveryOrderLinesList from '../../../../components/Purchasing/DeliveryOrder/Lines/DeliveryOrderLinesList'
import DeliveryOrderLinesModal from '../../../../components/Purchasing/DeliveryOrder/Lines/DeliveryOrderLinesModal'

import React, { Fragment } from 'react'

function DeliveryOrderLines(props) {
  return (
    <Fragment>
      <DeliveryOrderLinesModal {...props} />
      <DeliveryOrderLinesList {...props} />
    </Fragment>
  )
}

export default DeliveryOrderLines
